/**
 * Salesforce Service
 */

import users from './users'
import roles from './roles'
import permissions from './permissions'
import apps from './apps'

export default {
    users,roles,permissions,apps
}